import { forwardRef, useCallback } from 'react';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { Controller } from 'react-hook-form';

export const Checkbox = forwardRef((props, ref) => {
  const { checked, disabled, label, onChange, labelClassName = '', ...restProps } = props;

  const handleChange = useCallback(
    (e) => {
      onChange?.(e);
    },
    [onChange]
  );

  return (
    <label className={'cursor-pointer'}>
      <input ref={ref} className={'hidden'} type="checkbox" disabled={disabled} checked={checked} onChange={handleChange} {...restProps} />

      <div role={'checkbox'} className={'gap-2 flex items-center'}>
        {checked ? <CheckBoxIcon className={'text-orange-500'} /> : <CheckBoxOutlineBlankIcon className={'text-gray-400'} />}

        <div className={'flex items-center justify-center gap-x-1'}>
          <span className={`text-gray-400 text-sm ${labelClassName}`}>{label}</span>
          {restProps.icon && restProps.icon}
        </div>
      </div>
    </label>
  );
});

// контролируемый Checkbox с react-hook-form:
export const ControlledCheckbox = ({ control, name, defaultValue, onChange, ...restProps }) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue && defaultValue}
      render={({ field: { value, onChange, ...inputProps } }) => (
        <Checkbox
          checked={Boolean(value)}
          onChange={(value) => {
            onChange(value);
          }}
          {...inputProps}
          {...restProps}
        />
      )}
    />
  );
};
